import React from "react";
import data from "./data";
import FAQ from "../../components/FAQ";
import "./faqs.css";

const FAQs = () => {
  return (
    <section id="faqs">
      <h2 data-aos="fade-up">FaQ</h2>
      <p data-aos="fade-up">Frequently Asked Questions. </p>
      <div className="container faqs__container" data-aos="fade-right">
        {data.map((faq) => (
          <FAQ key={faq.id} faq={faq} />
        ))}
      </div>
      <p data-aos="fade-up" style={{ marginTop: "3rem" }}>
        <h3>FAQs do not answer your concerns ?</h3>
        Please,{" "}
        <a
          className="faq_a"
          href="mailto:projet@socaed.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "hsl(240, 25%, 25%);", fontStyle: "italic" }}
        >
          write to us
        </a>
        , we will be happy to answer you
      </p>
    </section>
  );
};

export default FAQs;
